import z from 'zod'
import {
  firestoreWriteTimestamp,
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
  nullSafeOptionalStringArray,
  nullSafeString,
} from '../shared/schema'

// this is the dart definition
// required String exhibitDescription, default: ''
// required bool exhibitHasThumbnail, default: false
// required String exhibitName, default: ''
// String? slideId,
// String? exhibitURL,
// int? updatedAt,
export const schema = z.object({
  exhibitDescription: nullSafeString(''),
  exhibitHasThumbnail: nullSafeOptionalBoolean(),
  exhibitName: nullSafeString(''),
  slideId: nullSafeOptionalString(),
  exhibitURL: nullSafeOptionalString(),
  exhibitMarkdown: nullSafeOptionalString(),
  exhibitAltText: nullSafeOptionalString(),
  exhibitImageFilename: nullSafeOptionalString(),
  mediaId: nullSafeOptionalString(),
  exhibitThumbnailURL: nullSafeOptionalString(),
  assignmentRoles: nullSafeOptionalStringArray([]),
  inputSources: z
    .array(
      z.object({
        questionId: z.string(),
        variableName: z.string(),
        representationType: z.enum(['text', 'group', 'individual']),
      })
    )
    .optional()
    .default([]),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const writeSchema = schema.extend({
  updatedAt: firestoreWriteTimestamp,
  exhibitURL: z.string().optional(),
  exhibitHasThumbnail: z.boolean().optional(),
  exhibitMarkdown: z.string().optional(),
  mediaId: z.string().optional(),
})

export const empty = Object.freeze(
  schema.parse({
    exhibitDescription: '',
    exhibitHasThumbnail: false,
    exhibitName: '',
  })
)

export type FirestoreSlideDeckExhibit = z.infer<typeof schema>
export type FirestoreSlideDeckExhibitWrite = z.infer<typeof writeSchema>
